<template>
  <div v-if="buttonInfo !== null" data-test-level-two-buttons>
    <!-- Policy Level 2 - ButtonLinkModels - Links for large screens-->
    <div class="policy-action-links medium-6 small-12">
      <a
        v-if="buttonInfo.showPolicyDetailsPageButton"
        :href="buttonInfo.policyDetailsPageButtonUrl"
        class="button large"
        data-test-policy-details-btn
        data-clickcategory="Tilgå forsikring"
        data-clickaction="se detaljer - klik"
        :data-clicklabel="clickPolicy(buttonInfo.productName.toLowerCase())"
        @click="sendEditTracking"
        v-html="buttonInfo.policyDetailsPageButtonText"
      />

      <a
        v-if="buttonInfo.showCreateClaimButton"
        :href="buttonInfo.createClaimButtonUrl"
        class="button large secondary"
        data-test-create-claim-btn
        @click="goToCreateClaimPage(buttonInfo.productName.toLowerCase())"
        v-html="buttonInfo.createClaimButtonText"
      />

      <green-card-download-button
        v-if="isVehiclePolicy && buttonInfo.downloadGreenCardPDFButtonText"
        :button-text="buttonInfo.downloadGreenCardPDFButtonText"
        :policy-number="buttonInfo.policyNumber"
      />

      <a
        v-for="(button, index) in buttonInfo.buttonLinkModels"
        :key="'button-l-' + index"
        :href="button.url"
        :target="button.target"
        data-test-link-models
        class="button large secondary"
        v-html="button.text"
      />

      <a
        v-if="buttonInfo.showChangeTermPageButton"
        :href="buttonInfo.changeTermPageButtonUrl"
        class="button large secondary"
        data-test-payment-frequency-btn
        @click="goToChangePaymentTermPage()"
        v-html="buttonInfo.changeTermPageButtonText"
      />

      <a
        v-if="buttonInfo.showFalckRoadsideAssistanceButton"
        :href="buttonInfo.falckRoadsideAssistanceButtonUrl"
        class="button large secondary"
        data-test-falck-roadside-assistance-btn
        target="_blank"
        v-html="buttonInfo.falckRoadsideAssistanceButtonText"
      />
    </div>
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import GreenCardDownloadButton from '../GreenCardDownload/GreenCardDownloadButton.vue';

export default {
  components: {
    GreenCardDownloadButton
  },
  props: {
    buttonInfo: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    isVehiclePolicy() {
      return this.buttonInfo.policyType === 'car'
        || this.buttonInfo.policyType === 'motorcycle'
        || this.buttonInfo.policyType === 'veteran';
    }
  },
  methods: {
    goToCreateClaimPage(name) {
      return this.$store.dispatch('Events/register', {
        event: `policy-section-click-create-claim-button-${name}`,
        id: 'policySection',
        vm: this
      });
    },
    goToChangePaymentTermPage() {
      return this.$store.dispatch('Events/register', {
        event: 'payment-term-level-two',
        id: 'paymentTerm'
      });
    },
    clickPolicy(val) {
      return Utility.shortenPolicyName(val);
    },
    sendEditTracking() {
      Utility.pushToTagManager({
        event: 'track-event',
        eventCategory: 'Tilgå forsikring',
        eventAction: 'se detaljer - klik',
        eventLabel: Utility.getShortPolicyName(this.buttonInfo.productName),
        eventValue: '0',
        eventNoninteraction: true
      });
    }
  }
};
</script>
